<template>
  <modal @modal-close="handleClose">
    <form
      class="bg-white rounded-lg shadow-lg overflow-hidden"
      style="width: 460px"
    >
      <div class="p-8">
        <div v-if="Object.keys(message).length" class="text-center text-80 leading-normal mb-6">
          <p v-if="message.limit" class="font-semibold text-xl">{{ message.limit + '/' + message.limit }}</p>
          <p>{{ `${message.text}. ${message.advice}` }}</p>
        </div>

        <UserCountField
          v-model="usersCount"
          :current-count="currentUserCount"
        />
      </div>

      <div class="bg-30 px-6 py-3 flex">
        <div class="ml-auto">
          <button
            type="button"
            class="btn text-80 font-normal h-9 px-3 mr-3 btn-link"
            @click.prevent="handleClose"
          >
            {{ $t('Cancel') }}
          </button>
          <button
            id="add-users"
            ref="confirmButton"
            :disabled="usersCount <= user._legacy_subscription.users.count"
            class="btn btn-default btn-danger"
            @click.prevent="handleUpgrade"
          >
            <span v-if="!updating">{{ $t('Add user seats') }}</span>
            <loader v-else />
          </button>
        </div>
      </div>
    </form>
  </modal>
</template>

<script>
  import subscriptionService from '@/_legacy/services/subscription';
  import UserCountField from '@/_legacy/components/Subscriptions/UserCountField.vue';

  export default {
    name: 'AddUsersModal',
    components: { UserCountField },
    props: {
      message: {
        type: Object,
        default: () => {},
      },
      user: {
        type: Object,
        default: () => {},
      },
    },

    data() {
      return {
        updating: false,
        usersCount: 0,
      };
    },

    computed: {
      currentUserCount() {
        return (this.user._legacy_subscription && this.user._legacy_subscription.users.count) || 1;
      },
    },

    watch: {
      user: {
        handler: 'updateUsersCount',
        immediate: true,
        deep: true,
      },
    },
    mounted() {
      this.$refs.confirmButton.focus();
    },
    methods: {
      updateUsersCount() {
        this.usersCount = this.user._legacy_subscription.users.count;
      },
      handleClose() {
        this.$emit('close');
      },
      handleUpgrade() {
        this.updating = true;
        subscriptionService.updateSubscription(this.user._legacy_subscription.plan, this.usersCount)
          .then(() => {
            this.$toasted.show(
              this.$t('Successfully updated!'),
              { type: 'success' },
            );
            this.$router.push({
              name: 'create',
              params: { resourceName: 'users' },
            });
          })
          .catch(e => {
            this.$toasted.show(
              this.$t(e.response.data.message),
              { type: 'error' },
            );
            this.updating = false;
          });
      },
    },
  };
</script>
